// @flow
import { List, Map }         from 'immutable';
import { Mixin }             from '../../../lib/trait';
import { Order }             from '../../../Models/Order';
import { Reducer }           from '../../Reducer';
import { ActiveItemFactory } from '../../Traits/ActiveItem';

import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateDone,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess
} from '../../utils';

import * as TYPES from './types';

const DEFAULT_STATE = Map({
    busy:        false,
    error:       null,
    items:       List([]),
    active:      null,
    activeError: null,
    item:        null,
});

/**
 * ActiveItemFactory
 * will build a custom class to fit with actual config
 * @type {ActiveItemClass}
 */
const ActiveItem = ActiveItemFactory({
    DEFAULT_STATE,
    TYPES,
    Model: Order
});

export default class OrdersReducer extends Mixin(Reducer, ActiveItem) {
    NAME = 'Orders';

    alias = {
        [ TYPES.ORDERS_GET_REQUEST ]: 'onGetRequest',
        [ TYPES.ORDERS_GET_SUCCESS ]: 'onGetSuccess',
        [ TYPES.ORDERS_GET_FAIL ]:    'onGetFailure',

        [ TYPES.ORDER_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.ORDER_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.ORDER_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.ORDER_CREATE_DONE ]:    'onItemCreateDone',

        [ TYPES.ORDER_LOAD_REQUEST ]: 'onItemLoadRequest',
        [ TYPES.ORDER_LOAD_SUCCESS ]: 'onItemLoadSuccess',
        [ TYPES.ORDER_LOAD_FAIL ]:    'onItemLoadFailure',

        [ TYPES.ORDER_UPDATE_REQUEST ]: 'onItemUpdateRequest',
        [ TYPES.ORDER_UPDATE_SUCCESS ]: 'onItemUpdateSuccess',
        [ TYPES.ORDER_UPDATE_FAIL ]:    'onItemUpdateFailure',
        [ TYPES.ORDER_UPDATE_DONE ]:    'onItemUpdateDone',

        [ TYPES.ACTIVE_SUCCESS ]: 'onActiveSuccess',
        [ TYPES.ACTIVE_CLEAN ]:   'onActiveClean',
        [ TYPES.ACTIVE_FAIL ]:    'onActiveError',

    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateDone = simpleOnItemUpdateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     */
    onActiveSuccess ( state = DEFAULT_STATE, { payload } ) {
        const { item, items } = payload;
        const active = new Order(item);

        return state.set('active', active)
            .set('items', items.map(( item ) => (
                Order.$instance(item) ? item : new Order(item)
            )));
    }

    /**
     *
     * @param state
     * @param payload
     */
    onActiveError ( state = DEFAULT_STATE, { payload } ) {
        return state.set('active', null)
            .set('activeError', payload);
    }

    /**
     *
     * @param state
     * @returns {*|Immutable.Map<any, any>|Immutable.Map<string, boolean>}
     */
    onActiveClean ( state = DEFAULT_STATE ) {
        return state.set('active', null)
            .set('activeError', null);
    }

    onDefault ( state = DEFAULT_STATE ) {
        return state;
    }
}
